import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
function VehicleServicePackages({ afleverpakketten }) {
    if (!(afleverpakketten === null || afleverpakketten === void 0 ? void 0 : afleverpakketten.afleverpakket))
        return null;
    const afleverpakkettenArray = Array.isArray(afleverpakketten.afleverpakket)
        ? afleverpakketten.afleverpakket
        : [afleverpakketten.afleverpakket];
    return (_jsxs("div", { className: "detail-content-box detail-content-box--packages", children: [_jsx("div", { className: "detail-content-heading", children: "Servicepakketten" }), afleverpakkettenArray.map((afleverpakket) => {
                const priceInt = parseInt(afleverpakket.prijs);
                return (_jsxs("div", { className: "detail-package-item", children: [_jsx("strong", { children: afleverpakket.naam }), _jsx("br", {}), _jsx("p", { dangerouslySetInnerHTML: { __html: afleverpakket.omschrijving } }), _jsxs("div", { children: ["\u20AC ", priceInt === null || priceInt === void 0 ? void 0 : priceInt.toLocaleString('nl-NL')] })] }, afleverpakket.naam));
            })] }));
}
export { VehicleServicePackages };
